import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  opassword: string;
  password: string;
  cpassword: string;
  passwordMatch: Boolean = false;
  signUpClicked: Boolean = false;
  somethingMissing: Boolean = false;
  changePassCount = 0;
  user: any;

  submitClicked: boolean = false;
  changePasswordForm: FormGroup;
  errorMessage: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        currentPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validators: [
          (formGroup: FormGroup) => {
            const { newPassword, confirmPassword } = formGroup.value;

            if (newPassword !== confirmPassword) {
              return { passwordsDontMatch: true };
            } else {
              return null;
            }
          },
        ],
      }
    );
  }

  handleChangePassword() {
    this.submitClicked = true;

    if (this.changePasswordForm.invalid) return;

    this.auth
      .updatePassword(this.changePasswordForm.value)
      .pipe(
        finalize(() => {
          this.submitClicked = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.auth.logout().subscribe(() => {
            this.router.navigate(['login']);
          });
        },
        (error) => {
          if (error.error.msg) {
            this.errorMessage = error.error.msg;
          } else {
            this.errorMessage = 'Something went wrong';
          }
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        }
      );
  }

  registerUsingPassowrd() {
    this.signUpClicked = true;
    this.checkPassConf();

    if (!this.opassword || !this.password || !this.cpassword) {
      this.signUpClicked = false;
      this.toastr.error('Fields can not be empty.');
    }

    this.changePassCount++;
    if (this.changePassCount > 1) {
      console.log('please wait');
      return;
    }

    let obj = {
      _currentPassword: this.opassword,
      _newPassword: this.password,
      _rPassword: this.cpassword,
    };

    this.auth.updatePassword(obj).subscribe(
      (updated) => {
        this.signUpClicked = false;
        if (updated['success']) {
          this.password = null;
          this.cpassword = null;
          this.opassword = null;
          this.changePassCount = 0;
          this.toastr.success('Password changed successfully.');
          setTimeout(() => {
            window.location.href = '/profile';
          }, 2000);
        } else {
          this.toastr.error(updated['msg']);
        }
      },
      (error) => {
        this.signUpClicked = false;
        this.toastr.error('Error Occurred. Please try again later.');
        console.log(error);
        this.changePassCount = 0;
      }
    );
  }

  checkPassConf() {
    if (this.password == this.cpassword) {
      this.passwordMatch = true;
    } else {
      this.toastr.warning('New Password Mismatch.');
      this.passwordMatch = false;
      return;
    }
  }
}
